/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Live_FinishInputs */

const en_features_live_finish = /** @type {(inputs: Features_Live_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish training`)
};

const pl_features_live_finish = /** @type {(inputs: Features_Live_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakończ trening`)
};

/**
* | output |
* | --- |
* | "Finish training" |
*
* @param {Features_Live_FinishInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_live_finish = /** @type {((inputs?: Features_Live_FinishInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Live_FinishInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_live_finish(inputs)
	return en_features_live_finish(inputs)
});